import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SystemAlert = ({ type, title, message, actionLabel, onAction, onDismiss }) => {
  const alertStyles = {
    info: {
      bg: 'bg-primary/10',
      border: 'border-primary/20',
      icon: 'Info',
      iconColor: 'text-primary'
    },
    success: {
      bg: 'bg-success/10',
      border: 'border-success/20',
      icon: 'CheckCircle',
      iconColor: 'text-success'
    },
    warning: {
      bg: 'bg-warning/10',
      border: 'border-warning/20',
      icon: 'AlertTriangle',
      iconColor: 'text-warning'
    },
    error: {
      bg: 'bg-error/10',
      border: 'border-error/20',
      icon: 'AlertCircle',
      iconColor: 'text-error'
    }
  };

  const style = alertStyles?.[type] || alertStyles?.info;

  return (
    <div className={`${style?.bg} ${style?.border} border rounded-lg p-3 md:p-4 mb-3 md:mb-4`}>
      <div className="flex items-start gap-3 md:gap-4">
        <div className={`${style?.iconColor} flex-shrink-0`}>
          <Icon name={style?.icon} size={20} className="md:w-6 md:h-6" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm md:text-base font-semibold text-foreground mb-1">{title}</h4>
          <p className="text-xs md:text-sm text-muted-foreground mb-3 md:mb-4">{message}</p>
          <div className="flex flex-wrap items-center gap-2 md:gap-3">
            {actionLabel && onAction && (
              <Button 
                variant="outline" 
                size="sm"
                onClick={onAction}
                className="text-xs md:text-sm"
              >
                {actionLabel}
              </Button>
            )}
            {onDismiss && (
              <button
                onClick={onDismiss}
                className="text-xs md:text-sm text-muted-foreground hover:text-foreground transition-smooth"
              >
                Dismiss
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemAlert;